import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { FadeIn } from "../../../../../common/components";
import { IconBetterspace } from "../../Icons";

interface AdminChipProps {
    isChecked: boolean;
    onToggle: (checked: boolean) => void;
}

const AdminChip = (props: AdminChipProps) => {
    const { isChecked, onToggle } = props;

    const { t } = useTranslation("common");

    return (
        <FadeIn>
            <button
                type="button"
                role="switch"
                aria-checked={isChecked}
                onClick={() => onToggle(!isChecked)}
                className={classNames(
                    "flex cursor-pointer items-center gap-1.5 rounded-full bg-surface-500 h-7 px-2.5 font-normal text-sm leading-none transition-[background] duration-150 hover:bg-surface-525 focus-visible:outline-2 focus-visible:outline-surface-500/40",
                    isChecked ? "text-text-500" : "text-text-300"
                )}
            >
                <div
                    className={classNames("size-3.5", {
                        "text-text-300 grayscale opacity-55": !isChecked,
                    })}
                >
                    <IconBetterspace />
                </div>
                {t("common:admin")}
            </button>
        </FadeIn>
    );
};

export default AdminChip;
